/* eslint-disable react-hooks/exhaustive-deps */

import { useTranslation } from "react-i18next";
import {
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import { Config } from "../../../utils/config";
import PaymentMethodCart from "./PaymentMethodCart";
import TableReservationDateAndTime from "./TableReservationDateAndTime";
import { useEffect } from "react";

export default function CartAccordionItem4({
  id,
  cartList,
  orderingMethod,
  authToken,
  restaurantDetail,
  handleCartList,
  handleAccordionClick,
}) {
  const { t } = useTranslation();
  const params = new URLSearchParams(window.location.search);
  const ordering_method =
    cartList?.orderingMethod?.ordering_method || params.get("type");
  // useEffect(() => {}, [orderingMethod]);

  return (
    <AccordionItem
      value="item-4"
      disabled={
        cartList?.orderingMethod === null ||
        cartList?.orderingMethod?.ordering_method !== ordering_method
      }
    >
      <AccordionTrigger>
        {Config.env.app.ordering_method_sub_type.map((item, index) => {
          if (orderingMethod === item.value) {
            return (
              <div key={index} className="flex space-x-3">
                <div>
                  <item.icon />
                </div>
                <div>{t(item.title)}</div>
              </div>
            );
          }
        })}
      </AccordionTrigger>
      {(ordering_method === "pickup" ||
        ordering_method === "delivery" ||
        ordering_method === "dine_in") && (
        <PaymentMethodCart
          cartList={cartList}
          authToken={authToken}
          id={id}
          restaurantDetail={restaurantDetail}
          handleCartList={handleCartList}
          handleAccordionClick={handleAccordionClick}
        />
      )}

      {(ordering_method === "table_reservation" ||
        ordering_method === "in_restaurant") && (
        <TableReservationDateAndTime
          cartList={cartList}
          authToken={authToken}
          id={id}
          restaurantDetail={restaurantDetail}
          handleCartList={handleCartList}
          handleAccordionClick={handleAccordionClick}
        />
      )}
    </AccordionItem>
  );
}
